var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"i_btn"},[_vm._v("立即购买")])}
var staticRenderFns = []

export { render, staticRenderFns }